import React from "react";
import { useTranslation } from "react-i18next";

function AboutSection() {
  const { t } = useTranslation();

  return (
    <section className="nw-section" id="about">
      <div className="nw-section-head">
        <h2>{t("about.title")}</h2>
        <p>{t("about.body")}</p>
      </div>
    </section>
  );
}

export default AboutSection;
